import { render, staticRenderFns } from "./SetupPrefixMaterial.vue?vue&type=template&id=67196eca&"
import script from "./SetupPrefixMaterial.vue?vue&type=script&lang=js&"
export * from "./SetupPrefixMaterial.vue?vue&type=script&lang=js&"
import style0 from "./SetupPrefixMaterial.vue?vue&type=style&index=0&id=67196eca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports